// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2k1HN","head":"ProcedureTableInfo_head__2ZRPQ"};